import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Acasa from "./pages/Acasa";
import Catalog from "./pages/Catalog";
import Servicii from "./pages/Servicii";
import Proiecte from "./pages/Proiecte";
import Contact from "./pages/Contact";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Acasa />} />
        <Route path="/catalog-mobila-bucuresti" element={<Catalog />} />
        <Route path="/servicii-mobila-la-comanda-sector-2" element={<Servicii />} />
        <Route path="/proiecte-mobila-sector-2-bucuresti" element={<Proiecte />} />
        <Route path="/contact-mobila-sector-2-bucuresti" element={<Contact />} />
      </Routes>
    </Router>
  );
}

export default App;
